import { defaultUnderlineStyle } from "@ecco/ui/css/common";
import type { CSSObject } from "@emotion/react";
import type { ButtonProps } from "@ecco/ui/button";
import { breakpoints, colors, space, typography } from "@ecco/ui/tokens";

const fs = typography.fontSizes;
const sp = space;

const { sm, md, lg } = breakpoints;

const heroRichTextLinkStyle = {
    color: "inherit",
    fontWeight: "bold",
    ...defaultUnderlineStyle,
    "&:hover": {
        color: colors.gray[500],
        textDecorationColor: colors.gray[500],
    },
};

const descriptionCss = {
    fontWeight: "bold",
    fontSize: fs.mobileBodyTextLarge,
    [`@media (min-width: ${sm})`]: {
        fontSize: fs.tableHeading3,
    },
    [`@media (min-width: ${md})`]: {
        fontSize: fs.desktopBodyTextLarge,
    },
    "& a, & button[data-type='modal-link']": heroRichTextLinkStyle,
    "& p": {
        fontSize: fs.mobileBodyTextLarge,
        fontWeight: "bold",
        marginBottom: 0,
        [`@media (min-width: ${sm})`]: {
            fontSize: fs.tableHeading3,
        },
        [`@media (min-width: ${md})`]: {
            fontSize: fs.desktopBodyTextLarge,
        },
    },
};

const legalTextCss = {
    fontSize: fs.mobileBodyB4,
    [`@media (min-width: ${lg})`]: {
        fontSize: fs.desktopBodyTextNormal,
    },
    "& a, & button[data-type='modal-link']": heroRichTextLinkStyle,
    "& p": { marginBottom: 0 },
};

const videoControlsWrapperCss = {
    position: "absolute",
    height: "100%",
    top: "0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    width: "100%",
} satisfies CSSObject;

const videoControlsStickyContainerCss = {
    minHeight: "30%",
    position: "sticky",
    bottom: "0",
} satisfies CSSObject;

const videoPosterCss = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 3,
} satisfies CSSObject;

const buttonProps = {
    display: "flex",
    height: { base: sp["9.6"], sm: sp["10.4"] },
    py: sp["3"],
    px: { base: sp["3"], sm: sp["4"] },
    justifyContent: "center",
    alignItems: "center",
    gap: sp["3"],
    fontSize: { base: fs.mobileBodyTextNormal, sm: fs.desktopBodyTextNormal },
    fontWeight: "bold",
    width: "unset",
    textDecoration: "none",
    _hover: {
        textDecoration: "none",
    },
} satisfies Partial<ButtonProps>;

export const styles = {
    description: descriptionCss,
    legalText: legalTextCss,
    videoControlsWrapper: videoControlsWrapperCss,
    videoControlsStickyContainer: videoControlsStickyContainerCss,
    videoPoster: videoPosterCss,
    button: buttonProps,
};

export const getOverlayPlayerStyle = (isMobile: boolean) => {
    return {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: 1,
        aspectRatio: isMobile ? "4/5" : "16/9",
    } as const;
};
